import moment from 'moment';
import { InputFromUser } from '../../../components/Input/input';

/**
 * Patient Plan Selector Component
 * Allows selection between multiple patient plans
 */
export const PatientPlanSelector = ({
    patientPlans,
    selectedPlanIndex,
    setSelectedPlanIndex,
}) => {
    return (
        <div className="col-12 mb-4">
            <div
                style={{
                    padding: '16px',
                    background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                    borderRadius: '8px',
                    border: '2px solid #2196f3',
                    boxShadow: '0 2px 8px rgba(33, 150, 243, 0.2)',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        flexWrap: 'wrap',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                        }}
                    >
                        <span
                            style={{
                                fontSize: '18px',
                                fontWeight: '600',
                                color: '#1565c0',
                            }}
                        >
                            📋 Select Patient Plan:
                        </span>
                        <span
                            style={{
                                fontSize: '14px',
                                color: '#1976d2',
                                background: 'white',
                                padding: '4px 12px',
                                borderRadius: '12px',
                                fontWeight: '500',
                            }}
                        >
                            {patientPlans.length} plans found
                        </span>
                    </div>
                    <div style={{ flex: 1, minWidth: '300px', maxWidth: '500px' }}>
                        <InputFromUser
                            type="singleSelect"
                            name="selectedPlan"
                            placeholder="Choose a patient plan"
                            value={selectedPlanIndex}
                            onChange={(value) => setSelectedPlanIndex(value)}
                            options={patientPlans.map((plan, index) => ({
                                label: `Plan ${index + 1}: ${plan?.customerName || plan?.customerId?.name || 'Unknown'
                                    } - ${plan?.additionalInfo?.startDate
                                        ? moment(plan.additionalInfo.startDate).format('DD MMM YYYY')
                                        : 'No date'
                                    }`,
                                value: index,
                            }))}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
